import React from 'react';
import "../styles/components/Introduction.css"

function Introduction() {
  return (
    <section class="intro">
        <h2>INTRODUCTION</h2>
        <p>Crée en Juin 2021 à l'occasion de l'étape d'été du Valorant OpenTour, malgré quelques changements au cours de l'année, GrandSpirit est fier de son parcours français et européen avec des joueurs motivés, qui ont l'envie de gagner les meilleures compétitions dans les années à venir.</p>
    </section>
  )
}

export default Introduction